import { render, staticRenderFns } from "./VaffArrayOfObjectField.vue?vue&type=template&id=d3e835ec&scoped=true&"
import script from "./VaffArrayOfObjectField.vue?vue&type=script&lang=js&"
export * from "./VaffArrayOfObjectField.vue?vue&type=script&lang=js&"
import style0 from "./VaffArrayOfObjectField.vue?vue&type=style&index=0&id=d3e835ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e835ec",
  null
  
)

export default component.exports